import { SvgColor } from 'src/components/svg-color';

const NavBarIcon = (name: string, color?: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} color={color} />
);

export default NavBarIcon;
